import React from 'react';
// MUI v4 Core Imports
import { Link, Typography, Theme } from '@material-ui/core';
// MUI v4 Styles Imports
import { makeStyles } from '@material-ui/core/styles';
// FontAwesome Imports
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Define props for the component
interface EmailLinkProps {
  email: string;
}

// Define styles using makeStyles specifically for this component
const useStyles = makeStyles((theme: Theme) => ({
  emailLink: {
    display: 'inline-flex', // Align icon and text nicely
    alignItems: 'center',
    color: theme.palette.text.primary, // Or inherit, or a specific color
    '&:hover': {
      textDecoration: 'none', // Optional: remove underline on hover
      color: theme.palette.primary.main, // Optional: change color on hover
    },
  },
  emailIcon: {
    marginRight: theme.spacing(1), // Space between icon and text
    color: theme.palette.secondary.main, // Keep your icon color
  },
}));

export const EmailLink: React.FC<EmailLinkProps> = ({ email }) => {
  const classes = useStyles();

  return (
    <Link
      href={`mailto:${email}`}
      className={classes.emailLink}
      // underline="none" // Optional
    >
      <FontAwesomeIcon icon={faEnvelope} className={classes.emailIcon} />
      <Typography variant="body1" component="span" color='primary'>
        {email}
      </Typography>
    </Link>
  );
};
